<template>
    <div class="page no-top-bar">

        <div class="h-screen">
            <TopBarDetail
                :title="'ข้อตกลงและเงื่อนไข'"
                :isShowBack="true"
                :isShowFavorite="false"
                :isShowShare="false"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div class="mx-4">
                <iframe
                    title=""
                    class="min-height-custom w-full"
                    :src="urlterms()"
                ></iframe>
            </div>

        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
// component
import ConfigManager from "@/config/ConfigManager.js";
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
export default {
    name: 'Contactus',
    mixins: [AuthStatusMixin, ModalMixin],
    components: {
        TopBarDetail,
        //CheckBox,
    },
    data: function () {
        return {
            isCheck: true,
             msgModal: 'คุณต้องการต้องการยืนยันที่จะ ยกเลิกการยอม <span class="text-blue-1">รับเงือนไขและข้อตกลง และ นโยบายความเป็นส่วนตัวของ</span> เอสพลัสคะแนนที่มีอยู่ในบัญชีของคุณ จะถูกยกเลิก และไม่สามารถเข้าใช้งานบัชชี S Plus+ ของคุณได้อีก'
        };
    },
    computed: {
        txtConfirmCheck: function() {
            return 'ฉันได้อ่านและยอมรับ <span class="text-blue-1">ข้อตกลงและเงื่อนไข</span> ของ เอสพลัส'
        },
    },
    created: function() {
        this.tracking.screenName('term');
        this.tracking.event('term', 'view_term');
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        },
        onSetupModalCompleted: function() {
            this.inititalPdpaModal(); //ModalMixin
        },
        urlterms: function() {
            return ConfigManager.getMiscUrl() + '/seg/terms.html';

        },
        checkOpenModal: function(value) {
            if(!value) {
                this.modalController.cancelTermsAndPrivacyModal
                        .clearModal()
                        .setMsg(this.msgModal)
                        .setBtnOk('ยืนยันการยกเลิกการบันทึกข้อมูลทั้งหมด')
                        .show();
                this.modalController.cancelTermsAndPrivacyModal.onClickOk(() => {
                    BzbsProfile.cancelConsent().subscribe({
                        next: (data) => {
                            console.log(data);
                        },
                        error: (err) => {
                            this.errorApi(err);
                        },
                    });
                });
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .min-height-custom{
        min-height: calc(100vh - 100px);
    }
</style>
